import vm from "../main.js";
import conf from "../views/im/conf/index.js";
import StoreUtils from "./StoreUtils";
import WebsocketHeartbeatJs from "./WebsocketHeartbeatJs";
import MessageHanle from "./MessageHanle";
import store from "@/store";

import {
  ErrorType,
} from "./ChatUtils";

class RequestUtils {
  constructor() {
    this.instance = null;
    this.isRefreshing = false;
    this.subscribers = [];
  }

  /**
   * 单例构造方法，构造一个广为人知的接口，供用户对该类进行实例化
   * @returns {RequestUtils}
   */
  static getInstance() {
    if (!this.instance) {
      this.instance = new RequestUtils();
    }
    return this.instance;
  }

  /**
   * 带token的请求
   * @param url 请求路径
   * @param options 请求参数
   * @returns {Promise<Response | never>}
   */
  request(url, options, opt) {
    let self = this;
    let token = StoreUtils.getToken();
    opt = opt || {};

    if (opt.loading) {
      vm.$Spin.show({
          render: (h) => {
              return h('div', [
                  h('Icon', {
                      'class': 'spin-icon-load',
                      props: {
                          type: 'ios-loading',
                          size: 30
                      }
                  }),
                  h('div', 'Loading')
              ])
          }
      });
    }
    return self
      .timeoutFetch(
        fetch(url, {
          method: "POST",
          // model: "cros", //跨域
          headers: {
            Accept: "application/json",
            token: token
            // Authorization: "bearer " + access_token
          },
          body: options
        }),
        10000
      )
      .then(response => {
        vm.$Spin.hide();
        self.checkStatus(response, url, options);
        return response.json();
      })
      .then(response => {
        if (response.code == 1) {
          return response.data;
        } else if (response.code == 401) {
          location.href="/";
        } else {
          vm.$Message.error(response.msg);
          return Promise.reject();
        }
      });
  }

  /**
   * 检查token 是否失效，如果失效，刷新token
   * @param response 拦截的请求 response
   * @param url 请求路径
   * @param options 请求参数
   * @returns {Promise<any>|*}
   */
  checkStatus(response, url, options) {
    // eslint-disable-next-line no-console
    let self = this;
    if (response && response.status === 401) {
      // eslint-disable-next-line no-console
      // 这个Promise函数很关键
      let p = new Promise(resolve => {
        self.addSubscriber(() => {
          resolve(self.request(url, options));
        });
      });
      // eslint-disable-next-line no-console
      // 刷新token的函数,这需要添加一个开关，防止重复请求
      if (!self.isRefreshing) {
        self.isRefreshing = true;
        // self.flushToken();
      }
      return p;
    } else {
      return response;
    }
  }

  /**
   * 重新执行token 失效的函数
   */
  onAccessTokenFetched() {
    let self = this;
    // eslint-disable-next-line no-console
    self.subscribers.forEach(callback => {
      callback();
    });
    self.subscribers = [];
  }

  /**
   * 把请求的token 失效的函数放到 subscribers
   * @param callback 请求的token 失效的函数
   */
  addSubscriber(callback) {
    let self = this;
    // eslint-disable-next-line no-console
    self.subscribers.push(callback);
    // eslint-disable-next-line no-console
  }

  /**
   * 用户登录的方法
   * @param username 用户名
   * @param password 密码
   * @returns {Promise<Response>} 登录状态
   */
  login(username, password) {
    // let self = this;
    let param = new FormData();
    param.set("client_id", "v-client");
    param.set("client_secret", "v-client-ppp");
    param.set("grant_type", "password");
    param.set("scope", "select");
    param.set("username", username.trim());
    param.set("password", password.trim());
    return fetch(conf.getTokenUrl(), {
      method: "POST",
      model: "cros", //跨域
      headers: {
        Accept: "application/json"
      },
      body: param
    })
      .then(response => {
        return response.json();
      })
      .then(json => {
        if (json.code != 1) {        
          return new Promise((resolve, reject) => {
            reject(json.msg);
          });
        }
        return new Promise(resolve => {
          resolve(json.data);
        });
      });
  }

  /**
   * 刷新token
   * @returns {Promise<Response | never>}
   */
  flushToken(vue) {
    console.log(vue);
    let self = this;
    self.isRefreshing = true;
    let param = new FormData();
    param.set("client_id", "v-client");
    param.set("client_secret", "v-client-ppp");
    param.set("grant_type", "refresh_token");
    param.set("scope", "select");
    param.set("refresh_token", StoreUtils.getToken().refresh_token);
    return fetch(conf.getTokenUrl(), {
      method: "POST",
      model: "cros", //跨域
      headers: {
        Accept: "application/json"
      },
      body: param
    })
      .then(response => {
        // eslint-disable-next-line no-console
        if (response.status === 200) {
          return response.json();
        } else {
          return new Promise((resolve, reject) => {
            reject(ErrorType.FLUSH_TOKEN_ERROR);
          });
        }
      })
      .then(json => {
        StoreUtils.setToken(json);
        //把token 失效后的请求重新执行
        self.onAccessTokenFetched();
        self.isRefreshing = false;

        //清除原先的刷新缓存的定时器
        vue.$store.commit("clearFlushTokenTimerId");
        //刷新token 定时器
        let flushTokenTimerId = setTimeout(function() {
          self.flushToken(vue);
        }, (json.expires_in - 10) * 1000);
        //将定时器存储到 $store
        vue.$store.commit("setFlushTokenTimerId", flushTokenTimerId);
      });
  }

  timeoutFetch(fetchPromise, timeout) {
    let abortFn = null;

    //这是一个可以被reject的promise
    let abortPromise = new Promise(function(resolve, reject) {
      abortFn = function() {
        reject(ErrorType.TIMEOUT_ERROR);
      };
    });

    //这里使用Promise.race，以最快 resolve 或 reject 的结果来传入后续绑定的回调
    let abortAblePromise = Promise.race([fetchPromise, abortPromise]);

    setTimeout(function() {
      abortFn();
    }, timeout);

    return abortAblePromise;
  }

  async webSocketSend(action, data) {
    let ws = store.state.websocket.getWs();
    while (ws.readyState !== ws.OPEN) {
      await this.sleep(1);
    };
    let message = {
      "c" : "Message",
      "a" : action,
      "data" : data
    }
    store.state.websocket.send(JSON.stringify(message));
  }

  sleep (ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  };

  /**
   * websocket 连接处理
   * @param self vue
   */
  webSocketOperation(self, url) {
    let websocketHeartbeatJs = new WebsocketHeartbeatJs({
      url: url
    });
    websocketHeartbeatJs.onopen = function() {
    };
    websocketHeartbeatJs.onmessage = function(event) {
      let ret = JSON.parse(event.data);

      if (ret.platform) {
        MessageHanle.call(ret.platform, ret);  
      } else {      
        MessageHanle[ret.msgtype] && MessageHanle[ret.msgtype](ret);
      }

      // let data = ret.data;
      // if (ret.platform == 'lazada' && self.$store.state.lazada.sessionData[data.seller_id]) {
      //   let param = new FormData();
      //   param.set("seller_id", data.seller_id);
      //   param.set("session_id", data.data.session_id);
      //   RequestUtils.getInstance().request(conf.getSessionDetail('lazada'), param)
      //   .then(function (res) {
      //     res.seller_id = data.seller_id;
      //     self.$store.commit("lazada/updateSession", res);
      //     self.$store.commit("lazada/updateMessage", data)
      //   })
      // } else if (ret.platform == 'shopee' && self.$store.state.shopee.sessionData[data.shop_id]) {
      //   let param = new FormData();
      //   param.set("shop_id", data.shop_id);
      //   param.set("conversation_id", data.data.content.conversation_id);
      //   RequestUtils.getInstance().request(conf.getSessionDetail('shopee'), param)
      //   .then(function (res) {
      //     res.shop_id = data.shop_id;
      //     self.$store.commit("shopee/updateSession", res);
      //     self.$store.commit("shopee/updateMessage", data);
      //   })
      // }
    };

    websocketHeartbeatJs.onreconnect = function() {
      console.log("reconnecting...");
    };

    websocketHeartbeatJs.onerror = function() {
      self.$Message.error("网络断开，正在重连...");
      
    };
    self.$store.commit("setWebsocket", websocketHeartbeatJs);
  }
}

export default RequestUtils.getInstance();
